import React, { Component } from 'react'
import { Button, Form } from 'react-bootstrap'
import { db } from '../config/fire'
import Roomi from './RoomMain';
import Loader from './Loader';

export default class PassAuth extends Component {
    constructor(props) {
        super(props);
        document.title = "Please Enter Password";
        this.state = {
            roomId: this.props.roomid,
            rpass: '',
            meetname: this.props.title,
            error: '',
            load: true,
            rauthed: false,
        }
        this.handleChange = this.handleChange.bind(this);
        this.rauth = this.rauth.bind(this);

    }
    componentDidMount() {
        const roomref = db().ref('all-rooms/' + this.state.roomId);
        roomref.once('value', snapshot => {
            if (snapshot.exists()) {

                const data = snapshot.val();

                this.setState({
                    rpass: data.pass,
                    load: false,
                })
            }
        })

    }
    rauth() {
        if (this.state.apwd === this.state.rpass) {
            console.log('Matched');
            this.setState({
                error: '',
                rauthed: true,
            })

        }
        else {
            this.setState({
                error: 'Password Error'
            })
        }

    }

    handleChange(event) {
        this.setState({
            [event.target.name]: event.target.value
        });
    }

    render() {
        return (
            this.state.load == true ? <Loader /> :
                this.state.rauthed == true ? <Roomi title={this.state.meetname} host={false} roomid={this.state.roomId}></Roomi> :
                    <div>

                        <Form.Group controlId="formGroupPassword">
                            <Form.Label>Password</Form.Label>
                            <Form.Control name="apwd" onChange={this.handleChange} value={this.state.apwd} id="apwd" type="password" placeholder="Password" />
                        </Form.Group>
                        {this.state.error ? <p className="text-danger">{this.state.error}</p> : null}
                        <Button type="submit" onClick={this.rauth} variant="primary">Register</Button>
                    </div>
        )
    }
}
